// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3q4rk","additionalInfo":"AgreementModal_additionalInfo__5h2sh"};